{ avatarDomain } = require '@trello/config'
_ = require 'underscore'
makeErrorEnum = require 'app/scripts/lib/make-error-enum'

PluginModelSerializerError = makeErrorEnum 'PluginModelSerializer', [
  'InvalidField'
]

readJSONFields = (json, allowedFields, fields) ->
  if _.isEqual(['all'], _.values(fields))
    fields = allowedFields

  if _.any(fields, (field) -> field !in allowedFields)
    throw PluginModelSerializerError.InvalidField()

  _.pick(json, fields)

readModelFields = (model, allowedFields, fields, getters = {}) ->
  if _.isEqual(['all'], _.values(fields))
    fields = allowedFields

  _.chain(fields)
  .map (field) ->
    if field !in allowedFields
      throw PluginModelSerializerError.InvalidField()

    value = if getters[field]?
      getters[field](model, field)
    else
      model.get(field)

    [field, value]
  .object()
  .value()

serializePreview = (preview, fields = ['bytes', 'height', 'scaled', 'url', 'width']) ->
  readJSONFields preview, ['bytes', 'height', 'scaled', 'url', 'width'], fields

serializePreviews = (previews, fields) ->
  previews.map _.partial(serializePreview, _, fields)

serializeAttachment = (attachment, fields = ['all']) ->
  allowed = [
    'date',
    'edgeColor',
    'id',
    'idMember',
    'name',
    'previews',
    'url'
  ]
  readModelFields attachment, allowed, fields,
    previews: ->
      # We load the previews asynchronously, so we might not have them yet
      serializePreviews(attachment.get('previews') ? [])

serializeAttachments = (attachments, fields) ->
  attachments.map _.partial(serializeAttachment, _, fields)

serializeBoard = (board, fields = ['id', 'name']) ->
  allowed = [
    'customFields',
    'dateLastActivity',
    'id',
    'idOrganization',
    'labels',
    'members',
    'memberships',
    'name',
    'shortLink',
    'url'
  ]
  readModelFields board, allowed, fields,
    customFields: ->
      # confirm custom fields Power-Up is enabled on board
      if board.isCustomFieldsEnabled()
        serializeCustomFields(board.customFieldList)
      else
        []
    labels: ->
      serializeLabels(board.labelList, ['all'])
    members: ->
      serializeMembers(board.memberList, ['all'])
    memberships: ->
      serializeMemberships(board.get('memberships'), ['all'])

serializeOrganization = (organization, fields = ['id']) ->
  readModelFields organization, ['id', 'name'], fields

serializeCard = (card, fields = ['id', 'name']) ->
  allowed = [
    'address',
    'attachments',
    'badges',
    'closed',
    'coordinates',
    'cover',
    'customFieldItems',
    'dateLastActivity',
    'desc',
    'due',
    'dueComplete',
    'id',
    'idList',
    'idShort',
    'labels',
    'locationName',
    'members',
    'name',
    'shortLink',
    'url'
  ]
  readModelFields card, allowed, fields,
    attachments: ->
      serializeAttachments(card.attachmentList)

    cover: ->
      if (idAttachmentCover = card.get('idAttachmentCover'))?
        if (cover = card.attachmentList.get(idAttachmentCover))?
          return serializeAttachment(cover)

      null

    customFieldItems: ->
      if card.getBoard().isCustomFieldsEnabled()
        serializeCustomFieldItems(card.customFieldItemList)
      else
        []

    labels: ->
      serializeLabels(card.labelList)

    members: ->
      serializeMembers(card.memberList, ['all'])

serializeCards = (cards, fields = ['id', 'name']) ->
  # filter cards down to only those that have an ID
  # i.e. we want to ignore optimistically created cards that don't
  # exist for sure yet
  _.filter(cards, (card) -> card.get('id')?)
    .map _.partial(serializeCard, _, fields)

serializeCustomFieldOption = (customFieldOption, fields = ['all']) ->
  readModelFields customFieldOption, ['id', 'color', 'value', 'pos'], fields

serializeCustomFieldOptions = (customFieldOptions, fields = ['all']) ->
  customFieldOptions.map _.partial(serializeCustomFieldOption, _, fields)

serializeCustomField = (customField, fields = ['id', 'name', 'type']) ->
  allowed = [
    'id',
    'fieldGroup',
    'name',
    'pos',
    'type',
    'display'
  ]
  if customField.isList()
    readModelFields customField, allowed.concat(['options']), fields,
      options: ->
        serializeCustomFieldOptions(customField.optionList)
  else
    readModelFields customField, allowed, _.without(fields, 'options')

serializeCustomFields = (customFields, fields = ['all']) ->
  customFields.map _.partial(serializeCustomField, _, fields)

serializeCustomFieldItem = (customFieldItem, fields = ['all']) ->
  if customFieldItem.getType() == 'list'
    readModelFields customFieldItem, ['id', 'idCustomField', 'idValue'], _.without(fields, 'value')
  else
    readModelFields customFieldItem, ['id', 'idCustomField', 'value'], _.without(fields, 'idValue')

serializeCustomFieldItems = (customFieldItems, fields = ['all']) ->
  nonEmptyItems = _.filter(customFieldItems.models, (i) -> !i.isEmpty())
  nonEmptyItems.map _.partial(serializeCustomFieldItem, _, fields)

serializeLabel = (label, fields = ['id', 'name', 'color']) ->
  readModelFields label, ['id', 'name', 'color'], fields

serializeLabels = (labels, fields) ->
  labels.map _.partial(serializeLabel, _, fields)

serializeList = (list, fields = ['id', 'name']) ->
  readModelFields list, ['id', 'name', 'cards'], fields,
    cards: ->
      serializeCards(list.cardList.models, ['all'])

serializeLists = (lists, fields = ['id', 'name']) ->
  lists.map _.partial(serializeList, _, fields)

serializeMember = (member, fields = ['id', 'fullName', 'username']) ->
  readModelFields member, ['id', 'fullName', 'username', 'initials', 'avatar'], fields,
    fullName: ->
      member.get('fullName', false)

    initials: ->
      member.get('initials', false)

    avatar: ->
      avatarHash = member.get('avatarHash', false)
      if avatarHash
        return [avatarDomain, avatarHash, '170.png'].join('/')
      null

serializeMembers = (members, fields) ->
  members.map _.partial(serializeMember, _, fields)

serializeMembership = (membership, fields = ['idMember', 'memberType']) ->
  readJSONFields membership, ['deactivated', 'id', 'idMember', 'memberType', 'unconfirmed'], fields

serializeMemberships = (memberships, fields) ->
  memberships.map _.partial(serializeMembership, _, fields)

module.exports =
  Error: PluginModelSerializerError
  attachment: serializeAttachment
  attachments: serializeAttachments
  board: serializeBoard
  card: serializeCard
  cards: serializeCards
  list: serializeList
  lists: serializeLists
  member: serializeMember
  organization: serializeOrganization
